import mutations from './appointmentInpatient.mutations'
import actions from './appointmentInpatient.actions'
import getters from './appointmentInpatient.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
